// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"AboutTheTeam_headerWrapper__1P2cO","card":"AboutTheTeam_card__V42a1","twitter":"AboutTheTeam_twitter__3mevL","cardHeader":"AboutTheTeam_cardHeader__lUM12"};